import request from '@/utils/request'
import qs from 'qs'
import { baseurl } from "@/config/config"

export function getOrderList(params) {
    return request({
        url: '/orderProduct/getOrderList',
        method: 'get',
        params: params
    })

}


export function getOrderLast(params) {
    return request({
        url: '/orderProduct/getOrderLast',
        method: 'get',
        params: params
    })

}



export function addOrder(param) {
    return request({
        url: '/orderProduct/addOrder',
        method: 'post',
        data: qs.stringify(param)
    })

}

export function updateOrder(param) {
    return request({
        url: '/orderProduct/updateOrder',
        method: 'post',
        data: qs.stringify(param)
    })

}

export function recoveryOrder(param) {
    return request({
        url: '/orderProduct/recoveryOrder',
        method: 'post',
        data: qs.stringify(param)
    })

}

export function deleteOrder(param) {
    return request({
        url: '/orderProduct/deleteOrder',
        method: 'post',
        data: qs.stringify(param)
    })
}

export function orderExport(param) {

    
    let url = baseurl + "/orderProduct/export?orderCode="+param.orderCode+"&userUserName="+param.userUserName+"&status="+param.status+"&time_b="+param.time_b+"&time_e="+param.time_e
    console.log(url)
    window.location.href = url
}


export function createDevice(params) {
    return request({
        url: '/orderProduct/createDevice',
        method: 'post',
        data: qs.stringify(params)
    })

}
